import {AfterViewInit, Directive, ElementRef, Input, QueryList, ViewChildren} from '@angular/core';
import {
  GroupedCheckboxFilterComponent
} from "../search-filter/grouped-checkbox-filter/grouped-checkbox-filter.component";

@Directive({
  selector: '[brtSimpleAccordionSet]'
})
export class SimpleAccordionSetDirective implements AfterViewInit {

  // CSS CLASSES
  // .simple-accordion-set for main wrapper (required)
  // .simple-accordion-set__item for single element (required)
  // .simple-accordion-set__toggle for click event (required)
  // .simple-accordion-set__content-wrapper hides content (required)
  // .simple-accordion-set__content contains content (required)
  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    const htmlEl = this.el.nativeElement as HTMLElement;


    // Expand any item that is marked as opened by default in the markup
    htmlEl.querySelectorAll(".simple-accordion-set__item.opened").forEach((el) => {
      const contentWrapper = el.querySelector(".simple-accordion-set__content-wrapper") as HTMLElement;
      const content = el.querySelector(".simple-accordion-set__content") as HTMLElement;
      if(content && contentWrapper) {
        contentWrapper.style.height = content.clientHeight + "px";
      }
    });

    htmlEl.querySelectorAll(".simple-accordion-set__toggle").forEach((htmlTarget) => {
      htmlTarget.addEventListener("click", function () {
        const parentAccordion = htmlTarget
          .closest(".simple-accordion-set__item");
        const targetState = !parentAccordion?.classList.contains("opened");
        htmlTarget.closest(".simple-accordion-set")
          ?.querySelectorAll(".simple-accordion-set__item")
          .forEach((el) => {
            el.classList.remove("opened");
            const contentWrapper = el.querySelector(".simple-accordion-set__content-wrapper") as HTMLElement;
            contentWrapper.style.height = `0`;
          });

        let targetHeight = 0;
        const contentWrapper = parentAccordion?.querySelector(".simple-accordion-set__content-wrapper") as HTMLElement;

        if(targetState) {
          targetHeight = contentWrapper.querySelector(".simple-accordion-set__content")?.clientHeight ?? 0;
        }
        contentWrapper.style.height = targetHeight + "px"
        htmlTarget
          .closest(".simple-accordion-set__item")
          ?.classList.toggle("opened", targetState);
      });
    })
  }

  recalculate() {
    const htmlEl = this.el.nativeElement as HTMLElement;

    htmlEl.querySelectorAll(".opened").forEach((el) => {
      const contentWrapper = el.querySelector(".simple-accordion-set__content-wrapper") as HTMLElement;
      const content = el.querySelector(".simple-accordion-set__content") as HTMLElement;
      if(content && contentWrapper) {
        contentWrapper.style.height = content.clientHeight + "px";
      }
    });
  }

}
